<template>
  <div>
    <SoundRecordingsTable />
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex"

import SoundRecordingsTable from "@/components/Pages/repertoire/SoundRecordingsTable.vue"

export default {
  name: "SoundRecordingsList",
  components: {
    SoundRecordingsTable
  },
  beforeRouteLeave (to, from, next) {
    // Clear filters
    this.clearFilters()
    next()
  },
  created () {
    // Check for query parameters and update filters accordingly
    let { status, member, use_type, eligible } = this.$route.query

    if (status) this.setStatusFilter(status)
    if (member) this.setMemberFilter({ "id": member })
    if (use_type) this.setUseTypeFilter({ "code": use_type })
    if (eligible) this.setShowIneligible(false)
  },
  methods: {
    ...mapActions("ui", ["clearFilters"]),
    ...mapMutations("ui", ["setStatusFilter", "setUseTypeFilter", "setMemberFilter", "setShowIneligible"]),
  },
  data () {
    return {}
  }
}
</script>
